function maskSensitiveInfo(data:any, show = false) {
    if (show) {
        return data;
    }
    if (data.length <= 4) {
        return '*'.repeat(data.length); // Mask all characters if the string is 4 or fewer characters
    }
    return '*'.repeat(data.length - 4) + data.slice(-4);
}
export default maskSensitiveInfo